import React, {useEffect, useState} from "react";
import Lightbox from "yet-another-react-lightbox";
import "./Gallery.css";
import "yet-another-react-lightbox/styles.css";
import ApiService from "../../../network/ApiService";
import {useSelector} from "react-redux";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function Gallery(props) {
    const {
        fetchGalleries,
    } = ApiService();
    const {organizationId} = useSelector((state) => state.organization);
    const languageStatus = sessionStorage.getItem("language");
    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);

    const [galleryData, setGalleryData] = useState([]);

    const fetchGalleryImages = async () => {
        try {
            const response = await fetchGalleries();
            setGalleryData(response.data.messageWithImg);
        } catch (error) {
            console.log(error.message);
        }
    };

    const handleViewSlides = (galleryImages) => {
        const images = [];
        galleryImages.map((value, item) => {
            images.push({
                src: value,
                alt: "image",
                width: 3840,
                height: 2560,
            });
        });
        setSlides(images);
        setOpen(!open);
    };

    useEffect(() => {
        if (organizationId) {
            fetchGalleryImages();
        }
    }, [organizationId]);

    return (
        <main id="main" className="mt-4 mb-4">
      <section id="about" className="about">
        <div className="container">
          <div className="section-title sticky_header" style={{width: props.sidebarwidth}}>
            <h2>{languageStatus === 'en' ? `Photo Gallery` : `फोटो ग्यालरी`}</h2>
          </div>
          <div className="col-md-12">
              <Lightbox
                  open={open}
                  close={() => setOpen(!open)}
                  slides={slides}
                  plugins={[Thumbnails]}
                  carousel={{finite: true}}
              />
              {galleryData.length > 0
                  ? galleryData.map((data, index) => {
                      return (
                          <div
                              className="card col-2 mb-5 gallery-image m-1"
                              key={index}
                              onClick={() => handleViewSlides(data.galleryUrls)}
                          >
                            <img
                                src={
                                    data.imageUrl && data.imageUrl !== "n/a"
                                        ? data.imageUrl
                                        : "assets/images/placeholder.jpg"
                                }
                            />
                            <div className=" mt-2 img-label text-center">
                              <span className="text-center">{languageStatus === 'en' ? (data.header ?? data.headerNp) : (data.headerNp ?? data.header)}</span>
                            </div>
                          </div>
                      );
                  })
                  : <>
                    <div style={{border: '1px solid', borderRadius: '5px', padding: '5px'}}>
                      <div
                          className="col-md-12"
                          style={{fontSize: '24px'}}
                      >
                        {languageStatus === 'en' ? `Photo Gallery Not Found` : `फोटो ग्यालरी भेटियन`}...
                      </div>
                    </div>
                </>}
          </div>
        </div>
      </section>
    </main>
    );
}

export default Gallery;
